"use client";

import { c as _c } from "react/compiler-runtime";
import { Activity, use } from "react";
import { fyllUtPlanSkjemaFullfortEvent, fyllUtPlanSkjemaStegFullfortEvent } from "@/common/analytics/events-and-properties/skjema-events";
import { logAnalyticsEvent } from "@/common/analytics/logAnalyticsEvent";
import type { ConvertedLagretUtkastResponse } from "@/schema/utkastResponseSchema";
import FyllUtPlanSteg from "./FyllUtPlanSteg/FyllUtPlanSteg";
import useOppfolgingsplanForm from "./FyllUtPlanSteg/form/hooks/useOppfolgingsplanForm";
import OppsummeringSteg from "./OppsummeringSteg/OppsummeringSteg";
export enum VeiviserSteg {
  FYLL_UT_PLAN = "FYLL_UT_PLAN",
  OPPSUMMERING = "OPPSUMMERING",
}
interface Props {
  lagretUtkastPromise: Promise<ConvertedLagretUtkastResponse>;
}
export default function LagPlanVeiviser(t0) {
  const $ = _c(35);
  const {
    lagretUtkastPromise
  } = t0;
  const {
    userHasEditAccess,
    utkast
  } = use(lagretUtkastPromise);
  const initialLagretUtkast = utkast?.content || null;
  const initialSistLagretTidspunkt = utkast?.sistLagretTidspunkt || null;
  let t1;
  if ($[0] !== initialLagretUtkast || $[1] !== initialSistLagretTidspunkt) {
    t1 = {
      initialLagretUtkast,
      initialSistLagretTidspunkt
    };
    $[0] = initialLagretUtkast;
    $[1] = initialSistLagretTidspunkt;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    form,
    veiviserSteg,
    focusThisOnValidationErrorsRef,
    isSavingUtkast,
    utkastSistLagretTidspunkt,
    isPendingProceedToOppsummering,
    isPendingExitAndContinueLater,
    isPendingFerdigstillPlan,
    saveIfChangesAndExit,
    goBackToFyllUtPlanSteg,
    lagreUtkastError,
    ferdigstillPlanError
  } = useOppfolgingsplanForm(t1);
  let t2;
  if ($[3] !== form) {
    t2 = function handleFortsettTilOppsummering() {
      logAnalyticsEvent(fyllUtPlanSkjemaStegFullfortEvent);
      form.handleSubmit({
        submitAction: "fortsettTilOppsummering"
      });
    };
    $[3] = form;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleFortsettTilOppsummering = t2;
  let t3;
  if ($[5] !== form) {
    t3 = function handleFerdigstillPlan() {
      logAnalyticsEvent(fyllUtPlanSkjemaFullfortEvent);
      form.handleSubmit({
        submitAction: "ferdigstill"
      });
    };
    $[5] = form;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleFerdigstillPlan = t3;
  const t4 = veiviserSteg === VeiviserSteg.FYLL_UT_PLAN ? "visible" : "hidden";
  let t5;
  if ($[7] !== saveIfChangesAndExit) {
    t5 = () => {
      saveIfChangesAndExit();
    };
    $[7] = saveIfChangesAndExit;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const t6 = !userHasEditAccess;
  let t7;
  if ($[9] !== focusThisOnValidationErrorsRef || $[10] !== form || $[11] !== handleFortsettTilOppsummering || $[12] !== isPendingExitAndContinueLater || $[13] !== isPendingProceedToOppsummering || $[14] !== isSavingUtkast || $[15] !== lagreUtkastError || $[16] !== t5 || $[17] !== t6 || $[18] !== utkastSistLagretTidspunkt) {
    t7 = <FyllUtPlanSteg form={form} isSavingUtkast={isSavingUtkast} isPendingProceedToOppsummering={isPendingProceedToOppsummering} isPendingExitAndContinueLater={isPendingExitAndContinueLater} utkastSistLagretTidspunkt={utkastSistLagretTidspunkt} errorSummaryRef={focusThisOnValidationErrorsRef} onAvsluttOgFortsettSenereClick={t5} onGoToOppsummeringClick={handleFortsettTilOppsummering} isFormReadOnly={t6} lagreUtkastError={lagreUtkastError} />;
    $[9] = focusThisOnValidationErrorsRef;
    $[10] = form;
    $[11] = handleFortsettTilOppsummering;
    $[12] = isPendingExitAndContinueLater;
    $[13] = isPendingProceedToOppsummering;
    $[14] = isSavingUtkast;
    $[15] = lagreUtkastError;
    $[16] = t5;
    $[17] = t6;
    $[18] = utkastSistLagretTidspunkt;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t4 || $[21] !== t7) {
    t8 = <Activity mode={t4}>{t7}</Activity>;
    $[20] = t4;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const t9 = veiviserSteg === VeiviserSteg.OPPSUMMERING ? "visible" : "hidden";
  let t10;
  if ($[23] !== ferdigstillPlanError || $[24] !== form || $[25] !== goBackToFyllUtPlanSteg || $[26] !== handleFerdigstillPlan || $[27] !== isPendingFerdigstillPlan) {
    t10 = <OppsummeringSteg form={form} isPendingFerdigstillPlan={isPendingFerdigstillPlan} onGoBack={goBackToFyllUtPlanSteg} onFerdigstillPlanClick={handleFerdigstillPlan} ferdigstillPlanError={ferdigstillPlanError} />;
    $[23] = ferdigstillPlanError;
    $[24] = form;
    $[25] = goBackToFyllUtPlanSteg;
    $[26] = handleFerdigstillPlan;
    $[27] = isPendingFerdigstillPlan;
    $[28] = t10;
  } else {
    t10 = $[28];
  }
  let t11;
  if ($[29] !== t10 || $[30] !== t9) {
    t11 = <Activity mode={t9}>{t10}</Activity>;
    $[29] = t10;
    $[30] = t9;
    $[31] = t11;
  } else {
    t11 = $[31];
  }
  let t12;
  if ($[32] !== t11 || $[33] !== t8) {
    t12 = <section>{t8}{t11}</section>;
    $[32] = t11;
    $[33] = t8;
    $[34] = t12;
  } else {
    t12 = $[34];
  }
  return t12;
}